var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "switch-button-control" }, [
    _c(
      "div",
      {
        staticClass: "switch-button",
        class: { enabled: _vm.isEnabled },
        style: { "--color": _vm.color },
        on: { click: _vm.toggle }
      },
      [_c("div", { staticClass: "button" })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "switch-button-label" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }